import React from 'react';
import {
    Tab, Nav, Col, NavItem, Row, Table, Modal
} from 'react-bootstrap';
import SweetAlert from "react-bootstrap-sweetalert";
import Button from '../../../elements/CustomButton/CustomButton.jsx';
import ModalRegistro from '../../Components/ModalRegistro.jsx';
import SolicitudFinanciera from '../../Components/SolicitudFinanciera.jsx';
import SolicitudServicio from '../../Components/SolicitudServicio.jsx';
import Checkbox from '../../../elements/CustomCheckbox/CustomCheckbox.jsx'
import { API_ROOT } from '../../../variables/api-config';
import ModalBlockWrapper from '../../Components/ModalBlockWrapper';

class RegistrosTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showRATModal: false,
      showRMModal: false,
      showRTModal: false,
      SAF: null,
      SS: null,
      currentTab: !this.props.currentTab ? 'RAT' : this.props.currentTab,
    };
    this.generateRAT = this.generateRAT.bind(this);
    this.generateRM = this.generateRM.bind(this);
    this.generateRT = this.generateRT.bind(this);
    this.saveRat = this.saveRat.bind(this);
    this.saveRt = this.saveRt.bind(this);
    this.saveRm = this.saveRm.bind(this);
    this.saveSs = this.saveSs.bind(this);
    this.saveSaf = this.saveSaf.bind(this);
    this.editSaf = this.editSaf.bind(this);
    this.editSs = this.editSs.bind(this);
    this.signRT = this.signRT.bind(this);
    this.signRM = this.signRM.bind(this);
    this.confirmSignRT = this.confirmSignRT.bind(this);
    this.confirmSignRM = this.confirmSignRM.bind(this);
  }

  generateRM() {
    const html = [];
    this.props.RMList.forEach((item, index) => {
      html.push(
        <tr key={index}>
          <td className="text-left">{item.id}</td>
          <td className="text-center">{item.fecha}</td>
          <td>{item.horas}</td>
          <td>
            <Checkbox
              disabled={parseInt(item.firmatutor, 10)}
              number={`${item.id}RM1`}
              label={'Tutor'}
              isChecked={parseInt(item.firmatutor, 10)}
              handleOnChange={(e) => this.confirmSignRM(item.id, e, 'firmatutor')}
            />
            <Checkbox
              disabled={parseInt(item.firmamentor, 10)}
              number={`${item.id}RM2`}
              label={'Mentor'}
              isChecked={parseInt(item.firmamentor, 10)}
              handleOnChange={(e) => this.confirmSignRM(item.id, e, 'firmamentor')}
            />
            <Checkbox
              disabled={parseInt(item.firmaemprendedor, 10)}
              number={`${item.id}RM3`}
              label={'Emprendedor'}
              isChecked={parseInt(item.firmaemprendedor, 10)}
              handleOnChange={(e) => this.confirmSignRM(item.id, e, 'firmaemprendedor')}
            />
          </td>
          <td className="text-right">
            <Button simple bsStyle="info" bsSize="xs">
              <a href={`${API_ROOT}/pdf/rm?id=${item.id}`}>
                <i className="fa fa-download"></i>
              </a>
            </Button>
          </td>
        </tr>
      )
    });
    return html;
  }

  generateRT() {
    const html = [];
    this.props.RTList.forEach((item, index) => {
      html.push(
        <tr key={index}>
          <td className="text-left">{item.id}</td>
          <td className="text-center">{item.fecha}</td>
          <td>{item.horas}</td>
          <td>
            <Checkbox
              disabled={parseInt(item.firmatutor, 10)}
              number={`${item.id}RT1`}
              label={'Tutor'}
              isChecked={parseInt(item.firmatutor, 10)}
              handleOnChange={(e) => this.confirmSignRT(item.id, e, 'firmatutor')}
            />
            <Checkbox
              disabled={parseInt(item.firmaasistentes, 10)}
              number={`${item.id}RT2`}
              label={'Asistentes'}
              isChecked={parseInt(item.firmaasistentes, 10)}
              handleOnChange={(e) => this.confirmSignRT(item.id, e, 'firmaasistentes')}
            />
          </td>
          <td className="text-right">
            <Button simple bsStyle="info" bsSize="xs">
              <a href={`${API_ROOT}/pdf/rt?id=${item.id}`}>
                <i className="fa fa-download"></i>
              </a>
            </Button>
          </td>
        </tr>
      )
    });
    return html;
  }

  generateRAT() {
    const html = [];
    this.props.RATList.forEach((item, index) => {
      html.push(
        <tr key={index}>
          <td className="text-left">{item.id}</td>
          <td className="text-center">{item.fecha}</td>
          <td>{item.horas}</td>
          <td className="text-right">
            <Button simple bsStyle="info" bsSize="xs">
              <a href={`${API_ROOT}/pdf/rat?id=${item.id}`}>
                <i className="fa fa-download"></i>
              </a>
            </Button>
          </td>
        </tr>
      )
    });
    return html;
  }

  generateSAF() {
    const html = [];
    this.props.SAFList.forEach((item, index) => {
      html.push(
        <tr key={index}>
          <td className="text-left">{item.id}</td>
          <td className="text-center">{item.fecha}</td>
          <td>{item.asistencia}</td>
          <td>{item.financiamiento}</td>
          <td>{item.responsable}</td>
          <td className="text-right">
            <Button simple bsStyle="info" bsSize="xs" onClick={() => this.editSaf(item.id)}>
              <i className="fa fa-edit"></i>
            </Button>
            <Button simple bsStyle="info" bsSize="xs">
              <a href={`${API_ROOT}/pdf/saf?id=${item.id}`}>
                <i className="fa fa-download"></i>
              </a>
            </Button>
          </td>
        </tr>
      )
    });
    return html;
  }

  generateSS() {
    const html = [];
    this.props.SSList.forEach((item, index) => {
      html.push(
        <tr key={index}>
          <td className="text-left">{item.id}</td>
          <td className="text-center">{item.fecha}</td>
          <td>{item.responsable}</td>
          <td className="text-right">
            <Button simple bsStyle="info" bsSize="xs" onClick={() => this.editSs(item.id)}>
              <i className="fa fa-edit"></i>
            </Button>
            <Button simple bsStyle="info" bsSize="xs">
              <a href={`${API_ROOT}/pdf/ss?id=${item.id}`}>
                <i className="fa fa-download"></i>
              </a>
            </Button>
          </td>
        </tr>
      )
    });
    return html;
  }

  confirmSignRT(id, signed, column) {
    if (signed) {
      this.props.showAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Marcar firmado"
          onConfirm={() => this.signRT(id, signed, column)}
          onCancel={() => this.props.hideAlert()}
          confirmBtnBsStyle="info"
          confirmBtnText="Aceptar"
          cancelBtnText="Cancelar"
          showCancel
        >
          Desea marcar este campo como firmado?
          <p>Tenga en cuenta que no podrá desmarcarlo en el futuro</p>
        </SweetAlert>
        );
    }
  }

  confirmSignRM(id, signed, column) {
    if (signed) {
      this.props.showAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Marcar firmado"
          onConfirm={() => this.signRM(id, signed, column)}
          onCancel={() => this.props.hideAlert()}
          confirmBtnBsStyle="info"
          confirmBtnText="Aceptar"
          cancelBtnText="Cancelar"
          showCancel
        >
          Desea marcar este campo como firmado?
          <p>Tenga en cuenta que no podrá desmarcarlo en el futuro</p>
        </SweetAlert>
        );
    }
  }

  signRT(id, signed, column) {
    this.props.incubationService.updateRTSign(id, signed ? 1 : 0, column)
    .then(res => {
      this.props.hideAlert();
      this.props.refreshRT();
    })
    .catch(err => {
      this.props.setError((<div>Ha ocurrido un error mientras actualizaba la firma, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      this.props.refreshRT();
    });
  }
  signRM(id, signed, column) {
    this.props.incubationService.updateRMSign(id, signed ? 1 : 0, column)
    .then(res => {
      this.props.hideAlert();
      this.props.refreshRM();
    })
    .catch(err => {
      this.props.setError((<div>Ha ocurrido un error mientras actualizaba la firma, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      this.props.refreshRM();
    });
  }

  editSaf(id) {
    this.props.incubationService
      .getSAFById(id)
      .then( res => {
        this.setState({ SAF: res.SAF, showSAFModal: true });
      })
      .catch(err => {
        this.props.setError((<div>Ha ocurrido un error mientras se cargaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }

  editSs(id) {
    this.props.incubationService
      .getSSById(id)
      .then( res => {
        this.setState({ SS: res.SS, showSSModal: true });
      })
      .catch(err => {
        this.props.setError((<div>Ha ocurrido un error mientras se cargaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }

  saveRat(rat) {
    this.props.incubationService
      .saveRat(rat)
      .then(res => {
        this.props.showAlert(
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="RAT cargada"
              onConfirm={() => this.props.hideAlert()}
              onCancel={() => this.props.hideAlert()}
              confirmBtnBsStyle="info"
              confirmBtnText="Aceptar"
            >
              {'Cambios guardados satisfactoriamente!'}
            </SweetAlert>
          );
        this.setState({showRATModal: false});
        this.props.refreshRAT();
      })
      .catch(err => {
        this.props.setError((<div>Ha ocurrido un error mientras se guardaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }
  saveRm(rm) {
    this.props.incubationService
      .saveRm(rm)
      .then(res => {
        this.props.showAlert(
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="RM cargada"
              onConfirm={() => this.props.hideAlert()}
              onCancel={() => this.props.hideAlert()}
              confirmBtnBsStyle="info"
              confirmBtnText="Aceptar"
            >
              {'Cambios guardados satisfactoriamente!'}
            </SweetAlert>
          );
        this.setState({showRMModal: false});
        this.props.refreshRM();
      })
      .catch(err => {
        this.props.setError((<div>Ha ocurrido un error mientras se guardaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }
  saveRt(rt) {
    this.props.incubationService
      .saveRt(rt)
      .then(res => {
        this.props.showAlert(
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="RT cargada"
              onConfirm={() => this.props.hideAlert()}
              onCancel={() => this.props.hideAlert()}
              confirmBtnBsStyle="info"
              confirmBtnText="Aceptar"
            >
              {'Cambios guardados satisfactoriamente!'}
            </SweetAlert>
          );
        this.setState({showRTModal: false});
        this.props.refreshRT();
      })
      .catch(err => {
        this.props.setError((<div>Ha ocurrido un error mientras se guardaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }
  saveSaf(saf) {
    this.props.incubationService
      .saveSaf(saf)
      .then(res => {
        this.props.showAlert(
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="SAF cargada"
              onConfirm={() => this.props.hideAlert()}
              onCancel={() => this.props.hideAlert()}
              confirmBtnBsStyle="info"
              confirmBtnText="Aceptar"
            >
              {'Cambios guardados satisfactoriamente!'}
            </SweetAlert>
          );
        this.setState({showSAFModal: false});
        this.props.refreshSAF();
      })
      .catch(err => {
        this.props.setError((<div>Ha ocurrido un error mientras se guardaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }
  saveSs(ss) {
    this.props.incubationService
      .saveSs(ss)
      .then(res => {
        this.props.showAlert(
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="SS cargada"
              onConfirm={() => this.props.hideAlert()}
              onCancel={() => this.props.hideAlert()}
              confirmBtnBsStyle="info"
              confirmBtnText="Aceptar"
            >
              {'Cambios guardados satisfactoriamente!'}
            </SweetAlert>
          );
        this.setState({showSSModal: false});
        this.props.refreshSS();
      })
      .catch(err => {
        this.props.setError((<div>Ha ocurrido un error mientras se guardaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }

  render() {
    let estado;
    if (this.props.state === 'pre-incubation') {
      estado = 'Pre Incubacion';
    } else if (this.props.state === 'incubation') {
      estado = 'Incubacion';
    }
    if (!this.props.RATList || !this.props.RMList || !this.props.RTList || !this.props.mentores) {
      return (<div></div>);
    }
    return (
        <div >
          <Tab.Container id="registros-tabs" defaultActiveKey="RAT">
            <Row className="clearfix">
              <Col sm={3}>
                <Nav bsStyle="pills" stacked>
                  <NavItem eventKey="RAT" title="Registro de asistencia técnica">Registro de asistencia técnica</NavItem>
                  <NavItem eventKey="RM" title="Registro de mentoría">Registro de mentoría</NavItem>
                  <NavItem eventKey="RT" title="Registro de tutoría">Registro de tutoría</NavItem>
                  <NavItem eventKey="SAF" title="Solicitud de asistencia financiera">Solicitud de asistencia financiera</NavItem>
                  <NavItem eventKey="SS" title="Solicitud de servicios">Solicitud de servicios</NavItem>
                </Nav>
              </Col>
              <Col sm={9} style={{border: 'solid 1px #59CAED'}}>
                <Tab.Content animation>
                  <Tab.Pane eventKey="RAT">
                    <div style={{textAlign:'right', paddingBottom:'5px'}}>
                      <Button bsStyle="primary" bsSize="sm" fill wd onClick={() => this.setState({ showRATModal: true })} >
                        Nuevo Registro
                      </Button>
                    </div>
                    <h6>Registros de asistencia tecnica</h6><br/>
                    {this.props.RATList.length === 0 ?
                      <div style={{ textAlign: 'center' }}>No hay registros</div> :
                      <Table responsive={true}>
                        <thead>
                          <tr>
                            <th>N°</th>
                            <th className="text-center">Fecha y Hora</th>
                            <th>horas</th>
                            <th className="text-right"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.generateRAT()}
                        </tbody>
                      </Table>
                    }
                  </Tab.Pane>
                  <Tab.Pane eventKey="RM">
                    <div style={{textAlign:'right', paddingBottom:'5px'}}>
                      <Button bsStyle="primary" bsSize="sm" fill wd onClick={() => this.setState({ showRMModal: true })}>
                        Nuevo Registro
                      </Button>
                    </div>
                    <h6>Registros de Mentoria</h6><br/>
                    {this.props.RMList.length === 0 ?
                      <div style={{ textAlign: 'center' }}>No hay registros</div> :
                      <Table responsive={true}>
                        <thead>
                          <tr>
                            <th>N°</th>
                            <th className="text-center">Fecha y Hora</th>
                            <th>horas</th>
                            <th>Firmas</th>
                            <th className="text-right"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.generateRM()}
                        </tbody>
                      </Table>
                    }
                  </Tab.Pane>
                  <Tab.Pane eventKey="RT">
                    <div style={{textAlign:'right', paddingBottom:'5px'}}>
                      <Button bsStyle="primary" bsSize="sm" fill wd onClick={() => this.setState({ showRTModal: true })}>
                        Nuevo Registro
                      </Button>
                    </div>
                    <h6>Registros de Tutoria</h6><br/>
                    {this.props.RTList.length === 0 ?
                      <div style={{ textAlign: 'center' }}>No hay registros</div> :
                      <Table responsive={true}>
                        <thead>
                          <tr>
                            <th>N°</th>
                            <th className="text-center">Fecha y Hora</th>
                            <th>horas</th>
                            <th>Firmas</th>
                            <th className="text-right"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.generateRT()}
                        </tbody>
                      </Table>
                    }
                  </Tab.Pane>
                  <Tab.Pane eventKey="SAF">
                    <div style={{textAlign:'right', paddingBottom:'5px'}}>
                      <Button bsStyle="primary" bsSize="sm" fill wd onClick={() => this.setState({ showSAFModal: true, SAF: null })}>
                        Nueva Solicitud
                      </Button>
                    </div>
                    <h6>Solicitudes de Asistencia Financiera</h6><br/>
                    {this.props.SAFList.length === 0 ?
                      <div style={{ textAlign: 'center' }}>No hay Solicitudes</div> :
                      <Table responsive={true}>
                        <thead>
                          <tr>
                            <th>N°</th>
                            <th className="text-center">Fecha y Hora</th>
                            <th>Asistencia</th>
                            <th>Financiamiento</th>
                            <th>Responsable</th>
                            <th className="text-right"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.generateSAF()}
                        </tbody>
                      </Table>
                    }
                  </Tab.Pane>
                  <Tab.Pane eventKey="SS">
                    <div style={{textAlign:'right', paddingBottom:'5px'}}>
                      <Button bsStyle="primary" bsSize="sm" fill wd onClick={() => this.setState({ showSSModal: true, SS: null })}>
                        Nueva Solicitud
                      </Button>
                    </div>
                    <h6>Solicitudes de Servicios</h6><br/>
                    {this.props.SSList.length === 0 ?
                      <div style={{ textAlign: 'center' }}>No hay Solicitudes</div> :
                      <Table responsive={true}>
                        <thead>
                          <tr>
                            <th>N°</th>
                            <th className="text-center">Fecha y Hora</th>
                            <th>Responsable</th>
                            <th className="text-right"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.generateSS()}
                        </tbody>
                      </Table>
                    }
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
          <Modal show={this.state.showRATModal} onHide={() => this.setState({showRATModal: false})} bsSize="large">
            <ModalBlockWrapper
              content={
                <div>
                  <Modal.Header closeButton>
                    <Modal.Title>Registro de Asistencia Técnica</Modal.Title>
                  </Modal.Header>
                  <ModalRegistro
                    type="RAT"
                    nombreproyecto={this.props.project.nombre} estado={estado}
                    cancel={() => this.setState({showRATModal: false})}
                    save={(rat) => this.saveRat(rat)} idproyectoincubacion={this.props.project.idproyectoincubacion}
                    setError={this.props.setError}
                  />
                </div>
              }
            />
          </Modal>
          <Modal show={this.state.showRTModal} onHide={() => this.setState({showRTModal: false})} bsSize="large">
            <ModalBlockWrapper
              content={
                <div>
                  <Modal.Header closeButton>
                    <Modal.Title>Registro de Tutoría</Modal.Title>
                  </Modal.Header>
                  <ModalRegistro
                    type="RT"
                    nombreproyecto={this.props.project.nombre} estado={estado}
                    cancel={() => this.setState({showRTModal: false})}
                    save={(rt) => this.saveRt(rt)} idproyectoincubacion={this.props.project.idproyectoincubacion}
                    setError={this.props.setError}
                  />
                </div>
              }
            />
          </Modal>
          <Modal show={this.state.showRMModal} onHide={() => this.setState({showRMModal: false})} bsSize="large">
            <ModalBlockWrapper
              content={
                <div>
                  <Modal.Header closeButton>
                    <Modal.Title>Registro de Mentoría</Modal.Title>
                  </Modal.Header>
                  <ModalRegistro
                    type="RM" mentores={this.props.mentores}
                    nombreproyecto={this.props.project.nombre} estado={estado}
                    cancel={() => this.setState({showRMModal: false})}
                    save={(rm) => this.saveRm(rm)} idproyectoincubacion={this.props.project.idproyectoincubacion}
                    setError={this.props.setError}
                  />
                </div>
              }
            />
          </Modal>
          {this.state.showSAFModal &&
            <SolicitudFinanciera
              nombreproyecto={this.props.project.nombre} estado={estado}
              cancel={() => this.setState({showSAFModal: false})}
              save={(saf) => this.saveSaf(saf)} idproyectoincubacion={this.props.project.idproyectoincubacion}
              solicitud={this.state.SAF} setError={this.props.setError}
            />
          }
          {this.state.showSSModal &&
            <SolicitudServicio
              nombreproyecto={this.props.project.nombre} estado={estado}
              cancel={() => this.setState({showSSModal: false})}
              save={(ss) => this.saveSs(ss)} idproyectoincubacion={this.props.project.idproyectoincubacion}
              solicitud={this.state.SS} setError={this.props.setError}
              />
            }
        </div>
    );
  }
}

export default RegistrosTab;



// WEBPACK FOOTER //
// ./src/views/Incubation/IncubationPage/RegistrosTab.jsx